interface Props {
  [key: string]: any
}

export default function CloseButtonIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 16 18" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M4.17383 12.826L11.826 4.47821M4.17383 4.47821L11.826 12.826"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.07085"
      />
    </svg>
  )
}
